import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {OperacionesComponent} from '../operaciones.component'
//Services
import {OperationService} from 'src/app/core/services/parameters/operation.service';
//Alert
import {AlertNoticeService} from 'src/app/core/alert/alert.service';

@Component({
  selector: 'edit-modal',
  templateUrl: './edit-modal.html',
  styleUrls: ['./edit-modal.component.scss']

})
export class EditarOperacionModal implements OnInit {

  editOperationForm: FormGroup;
  loading = false;
  showAlert = false;
  operationId;
  operationData = {
    id: '',
    createdAt: ''
  };

  constructor(
    public dialogRef: MatDialogRef<OperacionesComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private fb: FormBuilder,
    public alert: AlertNoticeService,
    private operationService: OperationService
  ) {
  }

  ngOnInit(): void {
    this.editOperationForm = this.fb.group({
      operation: [, Validators.required]
    })
    this.operationId = this.data.id;
    this.operationService.getOperationById(this.operationId).subscribe(_res => {
      this.operationData = _res;
      this.editOperationForm.patchValue({
        operation: _res.name
      })
    });
  }

  onNoClick(refresh): void {
    this.dialogRef.close(refresh);
  }

  get f() {
    return this.editOperationForm.controls;
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.editOperationForm.controls[controlName];
    if (!control) {
      return false;
    }

    const result = control.hasError(validationType) && (control.dirty || control.touched);
    return result;
  }

  submit(form) {
    this.loading = true;
    this.showAlert = false;
    if (form.valid) {
      const data = {
        name: form.value.operation
      }
      this.operationService.updateOperation(this.operationId, data).subscribe(_res => {
        this.alert.setNotice('Operación actualizada correctamente', 'success');
        this.showAlert = true;
        this.loading = false;
        setTimeout(() => this.onNoClick(true), 1000);
      }, _err => {
        this.alert.setNotice('No se pudo actualizar la operación', 'danger');
        this.showAlert = true;
        this.loading = false;
      })
    } else {
      this.loading = false;
    }
  }

}
